const shared = {
  rendering: 0,
  renderingCallbacks: []
}

export default shared
